import borderRadius from '@/styles/border_radius'
import spaceStyle from '@/styles/space'
import textAlign from '@/styles/text_align'
import { type ReactNode } from 'react'
import styled from 'styled-components'
import { Block } from '@/components/base/Block'
import { Heading3 } from '@/components/base/Heading'
import { useApp } from '@/hooks/useApp'
import { Icon } from '@/components/base/Icon'

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`

interface Props {
  children: ReactNode
}

const JobPostingCatchphraseComponent = ({ children }: Props): JSX.Element => {
  const app = useApp()
  return (
    <Block
      padding={{ all: spaceStyle.M }}
      textAlign={textAlign.LEFT}
      border
      borderRadius={{ all: borderRadius.L }}
    >
      <StyledContainer>
        <Icon
          iconType={'ICON_TYPE_FORMAT_QUOTE'}
          iconStyle={{
            margin: {
              right: spaceStyle.M
            },
            theme: app.theme.primaryMainColor
          }}
        />
        <Heading3 fixedSPfontSize margin={{ all: spaceStyle.NONE }}>
          {children}
        </Heading3>
      </StyledContainer>
    </Block>
  )
}

export default JobPostingCatchphraseComponent
